module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/client/client.component.css
// module id = ./src/app/client/client.component.css
// module chunks = main